export enum ActionEnum {
  SUBSCRIPTION = "subscription",
  BUY_MESSAGE = "buy_message",
  VIEW_POSTS = "view_posts",
  BUY_TG_POST = "buy_telegram_post",
  TIPS = "tips",
}
